import { put, select } from 'redux-saga/effects'
import _ from 'lodash'

import { groupStackSelector } from '../selectors'
import { loadGroupMembers, changeMembersPageLimit } from '../actions'

export default function* groupStackResizeSaga(action) {
    const size = _.get(action, 'data.size', null)

    const nextMembersCount = _.floor((size - 73) / 27) // 73 = 29 (header) + 44 (footer), 27 = height of row

    const { membersPerPage, activeGroup } = yield select(groupStackSelector)

    if (nextMembersCount !== membersPerPage) {
        yield put(changeMembersPageLimit(nextMembersCount))

        yield put(loadGroupMembers(activeGroup, 0, nextMembersCount))
    }

    return null
}
